import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import './DownloadMultipleSuplierFilesModal.scss';
import useHttp from 'utils/hooks/useHttp';
import { notify } from 'utils/marketplace';


type Props = {
  tariffs: Array<Tariff>,
  closeModal: (e: boolean) => void;
};

type Tariff = {
  codfou: string
  has_price: boolean
  logo: string
  supplier_logo: string
  supplier_name: string;
  type: string
  updated_at: string
};

const DownloadMultipleSuplierFilesModal: React.FC<Props> = (props) => {

  const { register, getValues, setValue, watch } = useForm();
  const [disableBtn, setDisableBtn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTariffsDownloadLaunched, setIsTariffsDownloadLaunched] = useState(false);
  const http = useHttp();

  const handleSubmitForm = () => {

    const selectedSuppliers = {
      'man': [],
      'sup': [],
    };

    getValues()['name'].forEach(item => {
      const [type, codfou] = item.split('_');

      selectedSuppliers[type].push(codfou);
    });

    setIsLoading(true);

    http.automotorTariff.downloadMultiplePricesFile(selectedSuppliers).then(
      () => {
        setIsLoading(false);
        setIsTariffsDownloadLaunched(true);
      }
    ).catch(() => {
      props.closeModal(true);
      notify('Internal Server Error');
    });
  };

  const { t } = useTranslation();

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setValue('name', props.tariffs?.map((item) => String(item.type) + '_' + item.codfou));
    }
    else {
      setValue('name', []);

    }
  };

  useEffect(() => {
    if (getValues()['name']?.length > 0) {
      if (getValues()['name']?.length === props.tariffs.length) {
        setValue('checkbox-all', true);
      }
      else {
        setValue('checkbox-all', false);
      }

      setDisableBtn(false);
    } else {
      setValue('checkbox-all', false);
      setDisableBtn(true);
    }
  }, [watch('name')]);


  return (
    <div className="modal_download_multiple_files ">
      <div className="close-modal" onClick={() => props.closeModal(false)}><FontAwesomeIcon icon={faClose} /></div>
      <div className="body-modal">
        {!isTariffsDownloadLaunched ?
          <React.Fragment>
            <div className="title_modal">{t('_download_tariffs')} </div>
            <div className="subtitle_modal" >{t('_select_tariff_to_download')}</div>
            <div className="form-group">
              {props.tariffs && props.tariffs.map((tariff, index) => {
                return <div className="checkbox-group" key={index}>
                  <div className="checkbox-center">
                    <div className="checkbox">
                      <input className="checkbox" type="checkbox" key={index} id={index + tariff.codfou} {...register('name')} value={tariff.type + '_' + tariff.codfou} />
                    </div>
                    <label htmlFor={index + tariff.codfou} className="supplier_name">{tariff.supplier_name}</label>
                  </div>
                </div>;
              })}
            </div>


            <div className="footer-modal">
              <div className="checkbox">
                <input type="checkbox" {...register('checkbox-all')} onChange={handleSelectAll} />
                <div className="supplier_name">{t('_select_all_tariffs')}</div>
              </div>
              <DefaultButton disabled={disableBtn} isloading={isLoading} text={t('_download_selected_tariffs')} onClick={() => { handleSubmitForm(); }} />
            </div>
          </React.Fragment>
          :
          <div className="wait_download_message">
            <Trans
              i18nKey="_wait_download_tariff_message"
              components={{ br: <br /> }}
            />

          </div>
        }
      </div>


    </div>
  );
};


export default DownloadMultipleSuplierFilesModal;


